const PledgeTypeRadio = ({ checked, name, value, handleChange, isHidden = false, children }) => {
    return (
        <label className={`pledge-type-option ${isHidden ? 'hide' : ''}`}>
            <input type='radio' name={name} value={value} onChange={handleChange} checked={checked} />
            {children}
        </label>
    )
}

export default PledgeTypeRadio